import { useQuery } from "@tanstack/react-query";
import type { Environment } from "../../../types";
import type { CrossdPosition, CrossdPositionsResponse } from "../types";
import { CROSS_DEFI_API } from "../constants";

export const CROSSD_POSITIONS_QUERY_KEY = "wp:crossd-positions";

/** 응답 envelope 유무를 방어하며 출금 가능한(liquidity>0) 포지션만 남긴다. */
export function parseCrossdPositions(json: unknown): CrossdPosition[] {
  const body = (json ?? {}) as CrossdPositionsResponse;
  const list = body.positions ?? body.data?.positions ?? [];
  return list.filter((p) => {
    if (!p?.token_id || !p.liquidity) return false;
    try {
      return BigInt(p.liquidity) > 0n;
    } catch {
      return false;
    }
  });
}

export function useCrossdPositions(
  env: Environment,
  walletAddress: string,
  enabled = true,
) {
  const hasAddress = enabled && !!walletAddress;

  const { data, ...rest } = useQuery<CrossdPosition[]>({
    queryKey: [CROSSD_POSITIONS_QUERY_KEY, env, walletAddress],
    queryFn: async () => {
      const res = await fetch(
        `${CROSS_DEFI_API[env]}/api/v1/positions?owner=${walletAddress}`,
        { cache: "no-store" },
      );
      if (!res.ok) {
        throw new Error(`crossd positions fetch failed: ${res.status}`);
      }
      return parseCrossdPositions(await res.json());
    },
    enabled: hasAddress,
    staleTime: 0,
  });

  const positions = data ?? [];

  return {
    positions,
    isEmpty: positions.length === 0,
    ...rest,
  };
}
